import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
  MSAL_GUARD_CONFIG,
} from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { XWareLogService } from '../services/xware-log.service';

@Injectable({
  providedIn: 'root',
})
export class CwMsalService {
  loggedIn: boolean;
  private readonly destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) public msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    private msalService: MsalService,
    private logger: XWareLogService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  cwAzureConfig() {
    this.logger.log('CwMsalService> checking account');
    if (this.msalService.instance.getAllAccounts().length > 0) {
      const accounts = this.msalService.instance.getAllAccounts();

      this.logger.log('CwMsalService> found accounts:' + accounts.length);

      for (let i = 0; i < accounts.length; i++) {
        this.logger.log(
          'CwMsalService> account:' +
            i +
            'user:' +
            accounts[i].username +
            ':tenant:' +
            accounts[i].tenantId +
            ':homeid:' +
            accounts[i].homeAccountId
        ); //use i instead of 0
      }
    } else {
      this.logger.log('CwMsalService> no accounts detected');
    }

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.destroying$)
      )
      .subscribe(result => {
        this.logger.log('CwMsalService> inprogessSubject event:' + JSON.stringify(result));
        this.checkAndSetActiveAccount();
      });

    this.msalBroadcastService.inProgress$.pipe(takeUntil(this.destroying$)).subscribe(result => {
      this.logger.log('CwMsalService> inprogessSubject2 event:' + JSON.stringify(result));
    });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this.destroying$)
      )
      .subscribe({
        next: (result: EventMessage) => {
          this.logger.log('CwMsalService> msalSubject event-login:' + JSON.stringify(result));
          if ((result.payload as AuthenticationResult).account) {
            this.logger.log(
              'CwMsalService> msalSubject event setting active account:' +
                (result.payload as AuthenticationResult).account.username +
                ':' +
                (result.payload as AuthenticationResult).tenantId
            );
            this.msalService.instance.setActiveAccount(
              (result.payload as AuthenticationResult).account
            );
          }
        },
        error: error => {},
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_FAILURE ||
            msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
        ),
        takeUntil(this.destroying$)
      )
      .subscribe(result => {
        this.logger.log('CwMsalService> msalSubject event-error:' + JSON.stringify(result));
      });
  }

  public signInAzure() {
    this.cwAzureConfig();
    this.logger.log('logincomponent:login called');
    if (this.msalService.instance.getAllAccounts().length > 0) {
      this.logger.log('logincomponent:user logged in redirecting');
      this.logger.log('logincomponent:user:' + this.msaluser().username);
      this.loggedIn = true;
      this.router.navigate(['/me/me-signature']);
    } else {
      this.logger.log('logincomponent:no user calling msal login');

      if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
        if (this.msalGuardConfig.authRequest) {
          this.msalService
            .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
            .subscribe((response: AuthenticationResult) => {
              this.logger.log(
                'getting account:popup:' +
                  response.account.tenantId +
                  ':' +
                  response.account.username
              );
              sessionStorage.setItem('lasthomeid', response.account.homeAccountId);
              this.msalService.instance.setActiveAccount(response.account);
              this.loggedIn = this.msalService.instance.getAllAccounts().length > 0;
            });
        }
      } else {
        this.logger.log('logincomponent:getting account-loginRedirect');

        if (this.msalGuardConfig.authRequest) {
          this.msalService.loginRedirect({
            ...this.msalGuardConfig.authRequest,
          } as RedirectRequest);
        } else {
          this.msalService.loginRedirect();
        }
      }
    }
  }

  msaluser(): any {
    this.logger.log('CwMsalService> msaluser called');
    if (!!this.msalService.instance.getActiveAccount()) {
      // this.logger.log('msaluser:got active account:'+this.msalService.instance.getActiveAccount().username + ":" + this.msalService.instance.getActiveAccount().tenantId);
      return this.msalService.instance.getActiveAccount();
    } else {
      //this.logger.log('msaluser:no active account got zero element:'+this.msalService.instance.getAllAccounts()[0].username + ":" + this.msalService.instance.getAllAccounts()[0].tenantId);
      return this.msalService.instance.getAllAccounts()[0];
    }
  }

  authuser(): any {
    return this.msaluser();
  }
  renderButtonSwitch(btnId: string) {
    //not implemented for msal
  }

  allmsalusers(): AccountInfo[] {
    return this.msalService.instance.getAllAccounts();
  }

  checkAndSetActiveAccount() {
    const activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      const accounts = this.msalService.instance.getAllAccounts();

      this.logger.log('checkAndSetActiveAccount:found accounts:' + accounts.length);

      for (let i = 0; i < accounts.length; i++) {
        this.logger.log(
          'checkAndSetActiveAccount:account:' +
            i +
            'user;' +
            accounts[i].username +
            ':tenant:' +
            accounts[i].tenantId +
            ':homeid:' +
            accounts[i].homeAccountId
        ); //use i instead of 0
      }

      const strID = sessionStorage.getItem('lasthomeid');
      if (!strID) {
        this.logger.log('CwMsalService> checkAndSetActiveAccount empty lastid');
        this.logger.log(
          'CwMsalService> checkAndSetActiveAccount setting active account:' +
            accounts[0].tenantId +
            ':' +
            accounts[0].username
        );

        this.msalService.instance.setActiveAccount(accounts[0]);
      } else {
        this.logger.log('CwMsalService> checkAndSetActiveAccount  lastid:' + strID);

        const account = this.msalService.instance.getAccountByHomeId(strID as string);
        if (account == null) {
          this.logger.log(
            'CwMsalService> checkAndSetActiveAccount null last account using zero:' +
              accounts[0].tenantId +
              ':' +
              accounts[0].username
          );
          this.msalService.instance.setActiveAccount(accounts[0]);
        } else {
          this.logger.log(
            'CwMsalService> checkAndSetActiveAccount last account:' +
              account.tenantId +
              ':' +
              account.username
          );
          this.msalService.instance.setActiveAccount(account);
        }
      }
    }
  }

  handleRedirect() {
    this.msalService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        this.logger.log('CwMsalService> handleRedirectObservable called:');
        if (result) {
          this.msalService.instance.setActiveAccount(result.account);
          sessionStorage.setItem('lasthomeid', result.account.homeAccountId);
          this.logger.log(
            'CwMsalService> handleRedirectObservable-login-result setting active account and lastid:' +
              result.account.username
          );
          this.router.navigate(['/me/me-signature']);
        } else {
          this.signInAzure();
        }
      },
      error: error => {
        this.logger.log('CwMsalService> handleRedirectObservable-login-error:' + JSON.stringify(error));
        this.router.navigate(['/me/me-signature']);
      },
    });
  }

  logout() {
    this.logger.log('cw-msal:logout called');
    const ob = sessionStorage.getItem('onboarding');
    sessionStorage.clear();
    if (ob === 'Y') {
      sessionStorage.setItem('onboarding', 'Y');
    }
    this.msalService.logout();
  }
}
